(() => {
  const TITLE_SELECTOR = [
    '.card__heading > a.x-card-title',
    '.card-info > a.x-card-title'
  ].join(', ');

  /*
   * Approved product-title line arrangements from the supplied spreadsheet.
   * Titles are matched case-insensitively and without punctuation/diacritics,
   * so both "Sexual" and "Séxūal" resolve consistently.
   */
  const RAW_TITLE_LINES = {
  "Séxūal Noir Eau de Parfum": [
    "Séxūal Noir",
    "Eau de Parfum"
  ],
  "Séxūal Gold Vanille Parfum": [
    "Séxūal Gold Vanille",
    "Parfum"
  ],
  "Séxūal Oud Rouge Parfum": [
    "Séxūal Oud Rouge",
    "Parfum"
  ],
  "Séxūal Noir Intense Eau de Parfum": [
    "Séxūal Noir Intense",
    "Eau de Parfum"
  ],
  "Séxūal Paris Eau de Parfum": [
    "Séxūal Paris",
    "Eau de Parfum"
  ],
  "Séxūal Sugar Eau de Parfum": [
    "Séxūal Sugar",
    "Eau de Parfum"
  ],
  "Séxūal Mini Perfume Bundle": [
    "Séxūal",
    "Mini Perfume",
    "Bundle"
  ],
  "Séxūal The Icons Bundle": [
    "Séxūal",
    "The Icons",
    "Bundle"
  ],
  "Séxūal Noir Gift Set": [
    "Séxūal Noir",
    "Gift Set"
  ],
  "Séxūal Gold Vanille Gift Set": [
    "Séxūal Gold Vanille",
    "Gift Set"
  ],
  "Séxūal Oud Rouge Gift Set": [
    "Séxūal Oud Rouge",
    "Gift Set"
  ],
   "Séxūal Oud Rouge Pour Homme Gift Set": [
    "Séxūal Oud Rouge",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Noir Intense Gift Set": [
    "Séxūal Noir Intense",
    "Gift Set"
  ],
  "Séxūal Gold Vanille Pour Homme Gift Set": [
    "Séxūal Gold Vanille",
     "Pour Homme",
    "Gift Set"
  ],
    "Séxūal Gold Vanille Pour Homme Gift Set": [
    "Séxūal Gold Vanille",
     "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Paris Gift Set": [
    "Séxūal Paris",
    "Gift Set"
  ],
  "Séxūal Sugar Gift Set": [
    "Séxūal Sugar",
    "Gift Set"
  ],
  "Séxūal Mini Parfum Gift Set": [
    "Séxūal",
    "Mini Parfum",
    "Gift Set"
  ],
  "Séxūal Gold Vanille Bundle": [
    "Séxūal Gold Vanille",
    "Bundle"
  ],
  "Séxūal Oud Rouge Bundle": [
    "Séxūal Oud Rouge",
    "Bundle"
  ],
  "Séxūal Noir Date Night Bundle": [
    "Séxūal Noir",
    "Date Night",
    "Bundle"
  ],
  "Séxūal Love Abroad Bundle": [
    "Séxūal",
    "Love Abroad",
    "Bundle"
  ],
  "Séxūal Secret Eau de Parfum": [
    "Séxūal Secret",
    "Eau de Parfum"
  ],
  "Séxūal Fleur Eau de Parfum": [
    "Séxūal Fleur",
    "Eau de Parfum"
  ],
  "Séxūal Fresh Eau de Parfum": [
    "Séxūal Fresh",
    "Eau de Parfum"
  ],
  "Séxūal Femme Eau de Parfum": [
    "Séxūal Femme",
    "Eau de Parfum"
  ],
  "Séxūal Paris Tendre Perfume Eau de Parfum": [
    "Séxūal Paris Tendre",
    "Eau de Parfum"
  ],
  "Séxūal Secret Gift Set": [
    "Séxūal Secret",
    "Gift Set"
  ],
  "Séxūal Fleur Gift Set": [
    "Séxūal Fleur",
    "Gift Set"
  ],
  "Séxūal Noir Body Lotion": [
    "Séxūal Noir",
    "Body Lotion"
  ],
  "Séxūal Sugar Massage Oil": [
    "Séxūal Sugar",
    "Massage Oil"
  ],
  "Séxūal Sugar Body Lotion": [
    "Séxūal Sugar",
    "Body Lotion"
  ],
  "Séxūal Noir Parfum Mini": [
    "Séxūal Noir",
    "Parfum Mini"
  ],
  "Séxūal Paris Parfum Mini": [
    "Séxūal Paris",
    "Parfum Mini"
  ],
  "Séxūal Sugar Parfum Mini": [
    "Séxūal Sugar",
    "Parfum Mini"
  ],
  "Séxūal Fleur Body Lotion": [
    "Séxūal Fleur",
    "Body Lotion"
  ],
  "Séxūal Paris Tendre Parfum Mini": [
    "Séxūal Paris Tendre",
    "Parfum Mini"
  ],
  "Séxūal Paris Parfum Mini": [
    "Séxūal Paris",
    "Parfum Mini"
  ],
  "Michel Germain Anti-Aging Hand & Body Moisturizer": [
    "Michel Germain",
    "Hand & Body",
    "Moisturizer"
  ],
  "Séxūal Parisian Date Night Bundle": [
    "Séxūal",
    "Parisian Date Night",
    "Bundle"
  ],
  "Séxūal  Discovery Set  Eau de Parfum": [
    "Séxūal",
    "Discovery Set",
    "Eau de Parfum"
  ],
  "Séxūal Paris Body Lotion": [
    "Séxūal Paris",
    "Body Lotion"
  ],
  "Séxūal Paris Massage Oil": [
    "Séxūal Paris",
    "Massage Oil"
  ],
  "Séxūal Noir Pour Homme Eau de Toilette": [
    "Séxūal Noir",
    "Pour Homme",
    "Eau de Toliette"
  ],
  "Séxūal Gold Vanille Pour Homme Eau de Parfum": [
    "Séxūal Gold Vanille",
    "Pour Homme",
    "Eau de Parfum"
  ],
  "Séxūal Oud Rouge Pour Homme Eau de Parfum": [
    "Séxūal Oud Rouge",
    "Pour Homme",
    "Eau de Parfum"
  ],
  "Séxūal Noir Pour Homme Eau de Parfum": [
    "Séxūal Noir Intense",
    "Pour Homme",
    "Eau de Parfum"
  ],
  "Séxūal Paris Pour Homme Eau de Toilette": [
    "Séxūal Paris",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Pour Homme Eau de Toilette": [
    "Séxūal",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Paris Tendre Pour Homme Eau de Toilette": [
    "Séxūal Paris Tendre",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Discovery Set Eau de Toilette": [
    "Séxūal",
    "Discovery Set",
    "Eau de Toilette"
  ],
  "Séxūal Noir Pour Homme Deodorant Stick": [
    "Séxūal Noir",
    "Pour Homme",
    "Deodorant Stick"
  ],
  "Séxūal Paris Pour Homme Deodorant Stick": [
    "Séxūal Paris",
    "Pour Homme",
    "Deodorant Stick"
  ],
  "Séxūal Pour Homme Deodorant Stick": [
    "Séxūal",
    "Pour Homme",
    "Deodorant Stick"
  ],
  "Séxūal Men’s Signature Bundle": [
    "Séxūal",
    "Men's Signature",
    "Bundle"
  ],
  "Séxūal Noir Pour Homme Gift Set": [
    "Séxūal Noir",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Gold Vanille Pour Homme Gift Set": [
    "Séxūal Gold Vanille",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Oud Rouge Pour Homme Gift Set": [
    "Séxūal Oud Rouge",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Noir Intense Pour Homme Gift Set": [
    "Séxūal Noir Intense",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Paris Pour Homme Gift Set": [
    "Séxūal Paris",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Pour Homme Gift Set": [
    "Séxūal",
    "Pour Homme",
    "Gift Set"
  ],
  "Séxūal Noir Date Night Bundle": [
    "Séxūal Noir",
    "Date Night",
    "Bundle"
  ],
  "Séxūal Parisian Date Night Bundle": [
    "Séxūal",
    "Parisian Date Night",
    "Bundle"
  ],
  "Séxūal Secret Man Eau de Toilette": [
    "Séxūal Secret",
    "Man",
    "Eau de Toilette"
  ],
  "Séxūal Steel Pour Homme Eau de Toilette": [
    "Séxūal Steel",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Noir Gift Set": [
    "Séxūal Noir ",
    "Gift Set"
  ],
  "Séxūal Paris Gift Set": [
    "Séxūal Paris",
    "Gift Set",
  ],
  "Séxūal Sugar Gift Set": [
    "Séxūal Sugar",
    "Gift Set",
  ],
  "Séxūal Fresh Pour Homme Eau de Toilette": [
    "Séxūal Fresh",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Secret Man 4-piece Cologne Gift Set": [
    "Séxūal Secret",
    "Man",
    "Gift Set"
  ],
  "Séxūal Steel Pour Homme Gift Set": [
    "Séxūal Steel",
    "Pour Homme",
    "Gift Set"
  ],
  "Michel Germain Skin Care Soap on a Rope": [
    "Michel Germain",
    "Soap on a Rope",
    "Skin Care"
  ],
  "Michel Germain Skin Care Massage Oil": [
    "Michel Germain",
    "Meassage Oil",
    "Skin Care"
  ],
  "Michel Germain Designer Weekender Bag": [
    "Michel Germain",
    "Designer",
    "Weekender Bag"
  ],
  "Michel Germain Egift card": [
    "Michel Germain",
    "Egift Card"
  ],
  "Sexual Pour Homme Aftershave": [
    "Séxūal",
    "Pour Homme",
    "Aftershave"
  ],
  "Sexual Pour Homme Massage Oil": [
    "Séxūal",
    "Pour Homme",
    "Massage Oil"
  ],
  "Michel Germain Skin Care Aftershave Balm": [
    "Michel Germain",
    "Aftershave Balm",
    "Skin Care"
  ],
  "Michel Collection Layering Bundle": [
    "Michel Collection",
    "Make it Yours Parfum",
    "Layering Bundle"
  ],
  "Michel - Orange Blossom Garden and French Vanilla Parfum": [
    "Michel Collection",
    "Orange Blossom",
    "Vanilla Parfum"
  ],
  "Michel - French Pear and Queen&#39;s Lilac Parfum": [
    "Michel Collection",
    "French Pear and",
    "Queen's Lilac Parfum"
  ],
  "Michel - Raspberry Royale and French Black Pepper Parfum": [
    "Michel Collection",
    "Raspberry Royale",
    "Black Pepper Parfum"
  ],
  "Michel - French Lavender and King&#39;s Glove Parfum": [
    "Michel Collection",
    "French Lavender and",
    "King's Glove Parfum"
  ],
  "Michel - Gold Bergamot and Vetiver Royale Parfum": [
    "Michel Collection",
    "Gold Bergamont",
    "Vetiver Royal Parfum"
  ],
  "Michel - French Oak and Sage Imperiale Parfum": [
    "Michel Collection",
    "French Oak and",
    "Sage Imperial Parfum"
  ],
  "Michel Collection Layering Kit (Discovery set) - 6 x 4 ml": [
    "Michel Collection",
    "Designed to Layer",
    "Discovery Set Parfum"
  ],
  "Michel - Orange Blossom Garden and French Vanilla Parfum Candle Bundle": [
    "Michel Collection",
    "Orange Blossom",
    "Vanilla Bundle"
  ],
  "Michel Collection - French Lavender and King&#39;s Glove Parfum &amp; Candle Bundle": [
    "Michel Collection",
    "French Lavender",
    "King's Glove Parfum Candle Bundle"
  ],
  "Michel - French Oak and Sage Imperiale Parfum &amp; Candle Bundle": [
    "Michel Collection",
    "French Oak",
    "Sage Imperial Bundle"
  ],
  "Michel - French Oak &amp; Sage Imperiale Parfum &amp; Candle Bundle": [
    "Michel Collection",
    "French Oak &",
    "Sage Imperiale Parfum & Candle Bundle",
  ],
  "Warm Layers of Romance bundle": [
    "Michel Collection",
    "Warm Layers Of",
    "Romance Bundle"
  ],
  "Layers of Delight Bundle": [
    "Michel Collection",
    "Layers Of Delight",
    "Bundle"
  ],
  "Michel Parfum Candle Set": [
    "Michel Collection",
    "Parfum",
    "Candle Set"
  ],
  "Michel - Orange Blossom Garden and French Vanilla Candle": [
    "Michel Collection",
    "Orange Blossom &",
    "Vanilla Candle"
  ],
  "Michel - French Lavender & King's Glove Candle": [
    "Michel Collection",
    "French Lavender",
    "King;s Glove Candle"
  ],
  "Michel - French Oak and Sage Imperiale Parfum Candle": [
    "Michel Collection",
    "French Oak",
    "Sage Imperial Candle"
  ],
  "Sugarful Pink Kiss Eau de Parfum": [
    "Sugarful Pink Kiss",
    "Eau de Parfum"
  ],
  "Sugarful Pink Kiss Gift Set": [
    "Sugarful Pink Kiss",
    "2-pc Gift Set"
  ],
  "Sugarful Mini Gift Set": [
    "Sugarful",
    "4-pc Mini Gift Set"
  ],
  "Sugarful OG Eau de Parfum": [
    "Sugarful OG",
    "Eau de Parfum"
  ],
  "Sugarful Gold Eau de Parfum": [
    "Sugarful Gold",
    "Eau de Parfum"
  ],
  "Sugarful Dream Eau de Parfum": [
    "Sugarful Dream",
    "Eau de Parfum"
  ],
  "Sugarful and Spice Eau de Parfum": [
    "Sugarful and Spice",
    "Eau de Parfum"
  ],
  "Sugarful Discovery Set - 3x 10 ml rollerball": [
    "Sugarful",
    "Rollerball Gift Set"
  ],
  "Sugarful OG Body Mist": [
    "Sugarful OG",
    "Body Mist"
  ],
  "Sugarful OG Glitter Body Lotion": [
    "Sugarful OG",
    "Glitter Body Lotion"
  ],
  "Sugarful OG 3- piece Gift Set": [
    "Sugarful OG",
    "3-pc Gift Set"
  ],
  "Sugarful OG 2-Piece Set": [
    "Sugarful OG",
    "2-pc Gift Set"
  ],
  "Sugarful Gold 2-piece Gift Set": [
    "Sugarful Gold",
    "2-pc Gift Set"
  ],
  "Sugarful Dream 2-piece Set": [
    "Sugarful Dream",
    "2-pc Gift Set"
  ],
  "Sugarful and Spice 2-Piece Set": [
    "Sugarful and Spice",
    "2-pc Gift Set"
  ],
  "Sugarful Sunshine 2-piece Set": [
    "Sugarful Sunshine",
    "2-pc Gift Set"
  ],
  "Sugarful Sweet Nothings 2-piece Gift set": [
    "Sugarful",
    "Sweet Nothings",
    "2-pc Gift Set"
  ],
  "Sugarful Sunshine Eau de Parfum": [
    "Sugarful Sunshine",
    "Eau de Parfum"
  ],
  "Sugarful Sweet Nothings Eau de Parfum": [
    "Sugarful",
    "Sweet Nothings",
    "Eau de Parfum"
  ],
  "Sugarful OG Lip Gloss": [
    "Sugarful OG",
    "Lip Gloss"
  ],
  "Sugarful and Spice Lip Gloss": [
    "Sugarful and Spice",
    "Lip Gloss"
  ],
  "Sugarful Noir Pour Homme Eau de Toilette": [
    "Sugarful Noir",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Sugarful Noir Pour Homme 2-piece Set": [
    "Sugarful Noir",
    "Pour Homme",
    "Gift Set"
  ],
  "Emily in Paris Life Chapters Bundles": [
    "Emily in Paris",
    "Life Chapters Bundle"
  ],
  "Emily in Paris Parisian Kiss Eau de Parfum": [
    "Emily in Paris",
    "Parsian Kiss",
    "Eau de Parfum"
  ],
  "Emily in Paris New Beginnings Eau de Parfum": [
    "Emily in Paris",
    "New Beginnings",
    "Eau de Parfum"
  ],
  "Emily in Paris Eau de Parfum": [
    "Emily in Paris",
    "Original",
    "Eau de Parfum"
  ],
  "Emily in Paris Heartfelt Eau de Parfum": [
    "Emily in Paris",
    "Heartfelt",
    "Eau de Parfum"
  ],
  "Emily in Paris Romantic Eau de Parfum": [
    "Emily in Paris",
    "Romantic",
    "Eau de Parfum"
  ],
  "Emily in Paris Je t'aime (I Love You) Eau de Parfum": [
    "Emily in Paris",
    "Je t'aime",
    "Eau de Parfum"
  ],
  "Emily in Paris Body Mist": [
    "Emily in Paris",
    "Original",
    "Body Mist"
  ],
  "Emily in Paris Heartfelt 2-piece Gift Set": [
    "Emily in Paris",
    "Heartfelt",
    "2-pc Gift Set"
  ],
  "Emily in Paris 3-piece Gift Set": [
    "Emily in Paris",
    "Original",
    "3-pc Gift Set"
  ],
  "Emily in Paris 3-piece Gift Set": [
    "Emily in Paris",
    "OG",
    "3-pc Gift Set"
  ],
  "Emily in Paris Famous Collection 4 x 100ml/3.4oz ": [
    "Emily in Paris",
    "Famous Bundle"
  ],
  "Emily in Paris Date Night Duo 2 x 100ml/3.4oz ": [
    "Emily in Paris",
    "Date Night Bundle"
  ],
  "Emily in Paris Pour Homme Eau de Toilette": [
    "Emily in Paris",
    "Pour Homme",
    "Eau de Toliette"
  ],
  "Emily in Paris Pour Homme 2-piece Gift Set": [
    "Emily in Paris",
    "Pour Homme",
    "Gift Set"
  ],
  "Emily in Paris Glow Up Trio Bundle": [
    "Emily in Paris",
    "Glow Up Bundle"
  ],
  "La Royale de Deauville Bundle": [
    "Deauville",
    "La Royale",
    "Bundle"
  ],
  "Deauville France L'Air de Fleur Perfume Eau de Parfum": [
    "Deauville",
    "L'air de Fleur",
    "Eau de Parfum"
  ],
  "Deauville France L'Air de Vivre Perfume Eau de Parfum": [
    "Deauville",
    "L'Air de Vivre",
    "Eau de Parfum"
  ],
  "Deauville France Pour Homme Eau de Parfum": [
    "Deauville",
    "Pour Homme",
    "Eau de Parfum"
  ],
  "Deauville France Yacht Club Pour Homme Eau de Parfum": [
    "Deauville Yacht Club",
    "Pour Homme",
    "Eau de Parfum"
  ],
  "Deauville Pour Homme Eau de Toilette": [
    "Deauville",
    "Pour Homme",
    "Eau de Toliette"
  ],
  "Seaside Escape Duo Bundle": [
    "Deauville",
    "Seaside Escape",
    "Bundle"
  ],
  "Coastal Regetta Duo Bundle": [
    "Deauville",
    "Coastal Regetta",
    "Bundle"
  ],
  "Deauville France Perfume Eau de Parfum": [
    "Deauville France",
    "Eau de Parfum"
  ],
  "Deauville Bleu Pour Homme Eau de Toilette": [
    "Deauville Bleu",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "David Pour Homme Eau de Toilette": [
    "David",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Tattoo Perfume Eau de Parfum": [
    "Tattoo Heart",
    "Perfume",
    "Eau de Parfum"
  ],
  "Tattoo Heart Pour Homme Eau de Toilette": [
    "Tattoo Heart",
    "Pour Homme",
    "Eau de Toilette"
  ],
  "Séxūal Noir Pour Homme Gift Set": [
    "Séxūal Noir",
    "Pour Homme",
    "Gift Set"
  ],
  "Sugarful Pour Homme 2-Piece Cologne Gift Set": [
    "Sugarful",
    "Pour Homme",
    "Gift Set"
  ],
    "Séxūal Creme Chocolat Eau de Parfum": [
    "Séxūal Creme Chocolat",
    "Eau de Parfum"
  ],
    "Séxūal Chocolat Noir Eau de Toilette": [
    "Séxūal Chocolat Noir",
    "Eau de Toilette"
  ]
};

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  function canonicalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenSignature(value) {
    return canonicalize(value)
      .split(' ')
      .filter(Boolean)
      .sort()
      .join(' ');
  }

  const TITLE_LINES = new Map(
    Object.entries(RAW_TITLE_LINES).map(([title, lines]) => [
      canonicalize(title),
      lines
    ])
  );

  /* Also match live titles whose approved words appear in a new order. */
  const SIGNATURE_LINES = new Map(
    Object.entries(RAW_TITLE_LINES).map(([title, lines]) => [
      tokenSignature(title),
      lines
    ])
  );

  const APPROVED_TITLE_ENTRIES = Object.entries(
    RAW_TITLE_LINES
  ).map(([title, lines]) => ({
    key: canonicalize(title),
    tokens: new Set(canonicalize(title).split(' ').filter(Boolean)),
    brand: canonicalize(lines[0] || ''),
    lines
  }));

  function findApprovedLines(title) {
    const key = canonicalize(title);

    const exactMatch =
      TITLE_LINES.get(key) ||
      SIGNATURE_LINES.get(tokenSignature(title));

    if (exactMatch) {
      return exactMatch;
    }

    /*
     * Live Shopify titles sometimes add, remove or misspell one word
     * compared with the approved sheet. Find the closest approved
     * title within the same brand so it still uses the approved lines.
     */
    const liveTokens = new Set(key.split(' ').filter(Boolean));
    let bestLines = null;
    let bestScore = 0;

    APPROVED_TITLE_ENTRIES.forEach(entry => {
      if (!entry.brand || !key.startsWith(entry.brand)) {
        return;
      }

      let sharedTokens = 0;

      entry.tokens.forEach(token => {
        if (liveTokens.has(token)) {
          sharedTokens++;
        }
      });

      const score = sharedTokens /
        Math.max(liveTokens.size, entry.tokens.size);

      if (score > bestScore) {
        bestScore = score;
        bestLines = entry.lines;
      }
    });

    return bestScore >= 0.7 ? bestLines : null;
  }


  function getOriginalTitle(element) {
    /* Eurus stores the clean product title in this attribute. */
    const customerData = element.getAttribute(
      'x-customer-event-data'
    );

    if (customerData) {
      try {
        const parsedData = JSON.parse(customerData);

        if (parsedData?.product?.title) {
          return String(parsedData.product.title)
            .replace(/\s+/g, ' ')
            .trim();
        }
      } catch (error) {
        /* Continue to the HTML fallback. */
      }
    }

    const clone = element.cloneNode(true);

    clone
      .querySelectorAll(
        '.x-review-product, .js-product-title-copy'
      )
      .forEach(node => node.remove());

    return clone.textContent
      .replace(/\s+/g, ' ')
      .trim();
  }

  function measureText(element, text) {
    const style = window.getComputedStyle(element);

    context.font = [
      style.fontStyle,
      style.fontWeight,
      style.fontSize,
      style.fontFamily
    ].join(' ');

    let width = context.measureText(text).width;
    const letterSpacing = parseFloat(style.letterSpacing);

    if (!Number.isNaN(letterSpacing) && text.length > 1) {
      width += letterSpacing * (text.length - 1);
    }

    return width;
  }

  function getAvailableWidth(element) {
    const style = window.getComputedStyle(element);
    const width = element.getBoundingClientRect().width;

    return width -
      (parseFloat(style.paddingLeft) || 0) -
      (parseFloat(style.paddingRight) || 0);
  }

  /*
   * Products not found in the CSV retain the previous automatic
   * three-line balancing behavior.
   */
  function findThreeLineSplit(element, title) {
    const words = title.trim().split(/\s+/);

    if (words.length < 3) {
      return [
        ...words,
        ...Array(3 - words.length).fill('')
      ];
    }

    const availableWidth = getAvailableWidth(element);

    if (availableWidth <= 0) {
      return null;
    }

    let bestLines = null;
    let bestScore = Infinity;

    for (
      let firstBreak = 1;
      firstBreak < words.length - 1;
      firstBreak++
    ) {
      for (
        let secondBreak = firstBreak + 1;
        secondBreak < words.length;
        secondBreak++
      ) {
        const lines = [
          words.slice(0, firstBreak).join(' '),
          words.slice(firstBreak, secondBreak).join(' '),
          words.slice(secondBreak).join(' ')
        ];

        const widths = lines.map(line =>
          measureText(element, line)
        );

        if (widths.some(width => width > availableWidth)) {
          continue;
        }

        const average =
          widths.reduce(
            (total, width) => total + width,
            0
          ) / 3;

        const score = widths.reduce(
          (total, width) =>
            total + Math.pow(width - average, 2),
          0
        );

        if (score < bestScore) {
          bestScore = score;
          bestLines = lines;
        }
      }
    }

    return bestLines;
  }

  function preserveReviewsAndClearTitle(element) {
    const allReviewElements = Array.from(
      element.querySelectorAll('.x-review-product')
    );

    /* Keep only the outermost review elements. */
    const reviewElements = allReviewElements.filter(review =>
      !allReviewElements.some(otherReview =>
        otherReview !== review &&
        otherReview.contains(review)
      )
    );

    /*
     * Detach the reviews first, clear every old title node/wrapper,
     * and then restore only the reviews. This prevents a parent
     * wrapper containing both a review and the old title from being
     * preserved and creating a duplicate title.
     */
    reviewElements.forEach(review => review.remove());
    element.replaceChildren();
    reviewElements.forEach(review => element.appendChild(review));
  }

  function isActualProductTitle(element) {
    if (element.closest('.x-review-product')) {
      return false;
    }

    const cardInfo = element.closest('.card-info');

    if (!cardInfo) {
      return true;
    }

    /*
     * In grid view, nested review links cause the browser to split
     * the Liquid title link. The real title becomes a direct child
     * of .card-info after the review block. Use that one only.
     */
    const directTitles = Array.from(cardInfo.children).filter(child =>
      child.matches?.('a.x-card-title') &&
      !child.closest('.x-review-product')
    );

    if (directTitles.length) {
      return directTitles.includes(element);
    }

    /* Normal list layout keeps the title inside .card__heading. */
    return element.matches('.card__heading > a.x-card-title');
  }

  function removeStaleFormattedTitle(element) {
    element
      .querySelectorAll(':scope > .js-product-title-copy')
      .forEach(node => node.remove());

    element.classList.remove(
      'js-semantic-title',
      'js-three-line-title'
    );
    element.removeAttribute('data-semantic-original-title');
    element.removeAttribute('data-original-title');
  }

  function renderTitle(element) {
    if (
      !(element instanceof Element) ||
      !element.matches(TITLE_SELECTOR)
    ) {
      return;
    }

    if (!isActualProductTitle(element)) {
      removeStaleFormattedTitle(element);
      return;
    }

    let originalTitle =
      element.dataset.semanticOriginalTitle;

    if (!originalTitle) {
      originalTitle = getOriginalTitle(element);

      if (!originalTitle) {
        return;
      }

      element.dataset.semanticOriginalTitle = originalTitle;
    }

    const approvedLines = findApprovedLines(originalTitle);

    const lines = approvedLines ||
      findThreeLineSplit(element, originalTitle);

    preserveReviewsAndClearTitle(element);

    element.classList.remove('js-three-line-title');
    element.classList.add('js-semantic-title');
    element.removeAttribute('data-original-title');

    const titleWrapper = document.createElement('span');
    titleWrapper.className = 'js-product-title-copy';

    if (!lines) {
      /* Allow very long unlisted titles to wrap naturally. */
      titleWrapper.textContent = originalTitle;
      element.appendChild(titleWrapper);
      return;
    }

    lines.forEach(line => {
      const span = document.createElement('span');

      span.className = 'title-line';
      span.textContent = line || '\u00A0';

      titleWrapper.appendChild(span);
    });

    element.appendChild(titleWrapper);
  }

  function renderAllTitles(container = document) {
    if (
      container instanceof Element &&
      container.matches(TITLE_SELECTOR)
    ) {
      renderTitle(container);
    }

    container
      .querySelectorAll?.(TITLE_SELECTOR)
      .forEach(renderTitle);
  }

  if (!document.getElementById('semantic-title-styles')) {
    const style = document.createElement('style');

    style.id = 'semantic-title-styles';
    style.textContent = `
      .x-card-title .js-product-title-copy,
      .x-card-title .js-product-title-copy .title-line {
        display: block;
      }
      .x-card-title .js-product-title-copy .title-line:first-child {
      font-weight: 600;
    }
    `;

    document.head.appendChild(style);
  }

  requestAnimationFrame(() => {
    renderAllTitles();
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(() => {
      renderAllTitles();
    });
  }

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      renderAllTitles();
    }, 150);
  });

  /* Supports collection filtering and infinite-scroll products. */
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node instanceof Element) {
          renderAllTitles(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();